import React from "react";
import Context from "../../../../../Context";
import Blocker from "../../../../Misc/Blocker";
import UserGroupPick from "../UserGroupPick";

const accessRights = {
  class: {
    deny: {
      ACCESS: parseInt("10000", 2),
      CREATE: parseInt("01000", 2),
      SELECT: parseInt("00100", 2),
      UPDATE: parseInt("00010", 2),
      DELETE: parseInt("00001", 2),
    },
    allow: {
      ACCESS: parseInt("10000", 2),
      CREATE: parseInt("01000", 2),
      SELECT: parseInt("00100", 2),
      UPDATE: parseInt("00010", 2),
      DELETE: parseInt("00001", 2),
    },
  },
  method: {
    deny: {
      EXECUTE: parseInt("100", 2),
      VISIBLE: parseInt("010", 2),
      ENABLE: parseInt("001", 2),
    },
    allow: {
      EXECUTE: parseInt("100", 2),
      VISIBLE: parseInt("010", 2),
      ENABLE: parseInt("001", 2),
    },
  },
};

export default class WorkflowSecurity extends React.Component {
  static contextType = Context;

  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      pick: false,
      activeItem: false,
      items: {},
    };

    this.apiPath = false;
    if (this.props.mode === "class") {
      this.apiPath = "/workflow/class/access";
      this.defaultAddMask = 16;
      this.bitsCount = 5;
    }
    if (this.props.mode === "method") {
      this.apiPath = "/workflow/method/access";
      this.defaultAddMask = 2;
      this.bitsCount = 3;
    }
  }

  deleteClick = (item) => {
    this.context
      .ask(`Удалить "${item.name}" из списка`, "Продолжить?", "question")
      .then((answer) => {
        if (answer.value) {
          this.delete(item);
        }
      });
  };

  delete = async (item) => {
    this.setState({ pending: true });
    let result = await this.context.api.q(this.apiPath + "/set", {
      id: this.props.objectId,
      userid: item.userid,
      mask: 0,
    });
    if (result !== false) {
      this.setState({ activeItem: false });
      await this.load();
      this.context.toast(`Настройки безопасности сохранены`, "success");
    } else {
      this.context.toast(
        `Не удалось сохранить настройки безопасности`,
        "error"
      );
    }
    this.setState({ pending: false });
  };

  load = async (setActive = false) => {
    if (!this.apiPath || !this.props.objectId) return false;
    this.setState({ pending: true });
    let items = await this.context.api.qo(
      this.apiPath,
      {
        id: this.props.objectId,
      },
      "userid"
    );
    let activeItem = this.state.activeItem || false;
    if (!activeItem && Object.keys(items).length)
      activeItem = Object.keys(items)[0];

    if (setActive) activeItem = setActive;

    this.setState({ pending: false, items, activeItem });
  };

  add = async (item) => {
    if (item) {
      this.setState({ pending: true });
      let result = await this.context.api.q(this.apiPath + "/set", {
        id: this.props.objectId,
        userid: item.id,
        mask: this.defaultAddMask,
      });
      if (result !== false) {
        await this.load(String(result.userid));
        this.context.toast(`Настройки безопасности сохранены`, "success");
      } else {
        this.context.toast(
          `Не удалось сохранить настройки безопасности`,
          "error"
        );
      }
      this.setState({ pending: false });
    }
  };

  maskMakeB = (mask) => {
    let result = mask.toString(2);
    while (result.length < this.bitsCount) result = "0" + result;
    return result;
  };

  save = async () => {
    let item = this.state.items[this.state.activeItem] || false;
    let rights = accessRights[this.props.mode] || false;
    if (item && rights) {
      let resultMask = {};
      ["allow", "deny"].forEach((grant) => {
        resultMask[grant] = 0;
        Object.entries(rights[grant]).forEach(([level, valueMask]) => {
          let elem = document.getElementById(`${grant}_${level}`) || {};
          if (elem.checked) {
            resultMask[grant] = resultMask[grant] | valueMask;
          }
        });
      });

      let mask = parseInt(
        this.maskMakeB(resultMask.deny) + this.maskMakeB(resultMask.allow),
        2
      );

      if (!mask) {
        let answer = await this.context.ask(
          `Снятие всех разрешений и всех ограничений приведет к удалению "${item.name}" из списка. `,
          "Продолжить?",
          "question"
        );
        if (!answer.value) return false;
      }

      let checkRecursive = document.getElementById(`recursive`) || {};
      let checkObjectset = document.getElementById(`objectset`) || {};

      let saveData = {
        id: this.props.objectId,
        userid: item.userid,
        mask,
      };

      if (this.props.mode === "class") {
        saveData.recursive = checkRecursive.checked ? true : false;
        saveData.objectset = checkObjectset.checked ? true : false;
      }

      this.setState({ pending: true });
      let result = await this.context.api.q(this.apiPath + "/set", saveData);
      if (result !== false) {
        if (!mask) this.setState({ activeItem: false });
        await this.load();
        this.context.toast(`Настройки безопасности сохранены`, "success");
      } else {
        this.context.toast(
          `Не удалось сохранить настройки безопасности`,
          "error"
        );
      }
      this.setState({ pending: false });
    } else {
    }
  };

  componentDidMount() {
    this.load();
  }

  renderList() {
    return (
      <>
        <div className="table-responsive">
          <table className="table w-100">
            <tbody>
              {Object.entries(this.state.items).map(([id, item]) => (
                <tr
                  onClick={() => this.setState({ activeItem: id })}
                  key={id}
                  className={`cursor-pointer ${
                    this.state.activeItem === id
                      ? "bg-light-primary"
                      : "bg-hover-light"
                  }`}
                >
                  <td className="">
                    {item.type === "G" ? (
                      <span
                        title="Группа"
                        className="text-muted flaticon2-group mr-2"
                      ></span>
                    ) : (
                      <span
                        title="Пользователь"
                        className="text-muted flaticon2-user-outline-symbol mr-2"
                      ></span>
                    )}
                    {item.name}
                  </td>
                  <td className="text-muted font-size-sm">
                    {item.description}
                  </td>
                  <td className="text-right">
                    <span
                      title="Удалить"
                      onClick={() => this.deleteClick(item)}
                      className="flaticon2-rubbish-bin px-2 align-middle cursor-pointer text-muted text-hover-danger"
                    ></span>
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan={5} className="text-right">
                  <span
                    title="Добавить пользователя или группу"
                    onClick={() => this.setState({ pick: true })}
                    className="flaticon2-add-1 px-2 align-middle cursor-pointer text-muted text-hover-primary"
                  ></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  }

  renderRights() {
    let item = this.state.items[this.state.activeItem] || false;
    let rights = accessRights[this.props.mode] || false;

    const Checkbox = ({ level, label, grant }) => (
      <label className="checkbox my-3">
        <input
          defaultChecked={rights[grant][level] & item[grant] ? true : false}
          type="checkbox"
          name={`${grant}_${level}`}
          id={`${grant}_${level}`}
        />
        <span className="mr-3"></span>
        {label}
      </label>
    );

    if (item && rights) {
      if (this.props.mode === "class")
        return (
          <>
            <hr />
            <h6 className="mb-7">{item.name}</h6>
            <div className="row">
              <div className="col-lg-6">
                <h6 className="mb-7 text-muted">Запретить</h6>
                <Checkbox grant="deny" level="ACCESS" label="Доступ" />
                <Checkbox grant="deny" level="CREATE" label="Создание" />
                <Checkbox grant="deny" level="SELECT" label="Чтение" />
                <Checkbox grant="deny" level="UPDATE" label="Изменение" />
                <Checkbox grant="deny" level="DELETE" label="Удаление" />
              </div>
              <div className="col-lg-6">
                <h6 className="mb-7 text-muted">Разрешить</h6>
                <Checkbox grant="allow" level="ACCESS" label="Доступ" />
                <Checkbox grant="allow" level="CREATE" label="Создание" />
                <Checkbox grant="allow" level="SELECT" label="Чтение" />
                <Checkbox grant="allow" level="UPDATE" label="Изменение" />
                <Checkbox grant="allow" level="DELETE" label="Удаление" />
              </div>
            </div>
            <div className="mt-10">
              <button className="btn btn-primary" onClick={this.save}>
                Сохранить
              </button>

              <label className="checkbox  mt-4">
                <input
                  defaultChecked={false}
                  type="checkbox"
                  name={`recursive`}
                  id={`recursive`}
                />
                <span className="mr-3"></span>
                Применить к вложенным классам
              </label>

              <label className="checkbox  mt-2">
                <input
                  defaultChecked={false}
                  type="checkbox"
                  name={`objectset`}
                  id={`objectset`}
                />
                <span className="mr-3"></span>
                Применить к существующим объектам
              </label>
            </div>
          </>
        );
      if (this.props.mode === "method")
        return (
          <>
            <hr />
            <h6 className="mb-7">{item.name}</h6>
            <div className="row">
              <div className="col-lg-6">
                <h6 className="mb-7 text-muted">Запретить</h6>
                <Checkbox grant="deny" level="EXECUTE" label="Выполним" />
                <Checkbox grant="deny" level="VISIBLE" label="Виден" />
                <Checkbox grant="deny" level="ENABLE" label="Включен" />
              </div>
              <div className="col-lg-6">
                <h6 className="mb-7 text-muted">Разрешить</h6>
                <Checkbox grant="allow" level="EXECUTE" label="Выполним" />
                <Checkbox grant="allow" level="VISIBLE" label="Виден" />
                <Checkbox grant="allow" level="ENABLE" label="Включен" />
              </div>
            </div>
            <div className="mt-10">
              <button className="btn btn-primary" onClick={this.save}>
                Сохранить
              </button>
              {this.props.onCancell ? (
                <button
                  className="btn btn-light ml-2"
                  onClick={this.props.onCancell}
                >
                  Отмена
                </button>
              ) : null}
            </div>
          </>
        );
    }
  }

  render() {
    return (
      <>
        <UserGroupPick
          show={this.state.pick}
          onHide={() => this.setState({ pick: false })}
          onSelect={this.add}
        />
        <Blocker on={this.state.pending}>
          {Object.keys(this.state.items).length ? this.renderList() : null}
          {this.renderRights()}
        </Blocker>
      </>
    );
  }
}
